export var EEndpoint = /*#__PURE__*/function (EEndpoint) {
  EEndpoint["CheckCtn"] = "/api/CtnStatus/Get/";
  return EEndpoint;
}({});
export var EUserType = /*#__PURE__*/function (EUserType) {
  EUserType[EUserType["Mobile"] = 0] = "Mobile";
  EUserType[EUserType["Fttb"] = 1] = "Fttb";
  return EUserType;
}({});
export var EResponseStatus = /*#__PURE__*/function (EResponseStatus) {
  EResponseStatus[EResponseStatus["IsBeelineUser"] = 1] = "IsBeelineUser";
  EResponseStatus[EResponseStatus["IsNonBeelineUser"] = 2] = "IsNonBeelineUser";
  return EResponseStatus;
}({});
export var EWidgetPayUrl = /*#__PURE__*/function (EWidgetPayUrl) {
  EWidgetPayUrl["Prod"] = "https://widgetpay1.beeline.ru/";
  EWidgetPayUrl["Dev"] = "";
  return EWidgetPayUrl;
}({});